import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Dumbbell, Zap, Activity, Flame, StretchHorizontal, Target, Weight, Crosshair, Music, Users, Heart, Baby } from 'lucide-react';
const disciplines = [{
  name: 'Musculación',
  icon: Dumbbell
}, {
  name: 'Preparación física deportiva',
  icon: Zap
}, {
  name: 'Funcional',
  icon: Activity
}, {
  name: 'Calistenia',
  icon: Flame
}, {
  name: 'Stretching',
  icon: StretchHorizontal
}, {
  name: 'GAP',
  icon: Target
}, {
  name: 'Levantamiento de pesas',
  icon: Weight
}, {
  name: 'Boxeo',
  icon: Crosshair
}, {
  name: 'Zumba',
  icon: Music
}];
const programs = [{
  name: 'Team Running',
  icon: Users
}, {
  name: 'Taller adultos mayores',
  icon: Heart
}, {
  name: 'Kiron Kids (6–10)',
  icon: Baby
}, {
  name: 'Baby Kiron (2–5)',
  icon: Baby
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    scale: 0.9
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4
    }
  }
};
export function ActivitiesSection() {
  return <section id="actividades" className="py-24 bg-kiron-black relative" data-id="element-25">
      <div className="max-w-7xl mx-auto px-6" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 text-center" data-id="element-27">
          <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white mb-4" data-id="element-28">
            Nuestras <span className="text-kiron-teal" data-id="element-29">Actividades</span>
          </h2>
          <div className="w-20 h-1 bg-kiron-teal mx-auto" data-id="element-30"></div>
        </motion.div>

        <div className="mb-16" data-id="element-31">
          <h3 className="text-2xl font-oswald text-gray-300 mb-8 border-l-4 border-kiron-teal pl-4" data-id="element-32">
            Disciplinas
          </h3>
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-33">
            {disciplines.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-kiron-darker p-6 flex flex-col items-center justify-center text-center hover:bg-kiron-teal hover:text-kiron-black transition-all duration-300 group cursor-default" data-id="element-34">
                <item.icon size={36} className="text-kiron-teal mb-4 group-hover:text-kiron-black transition-colors" data-id="element-35" />
                <span className="font-oswald font-semibold tracking-wide uppercase text-sm md:text-base" data-id="element-36">
                  {item.name}
                </span>
              </motion.div>)}
          </motion.div>
        </div>

        {/* Diagonal separator */}
        <div className="w-full h-12 bg-kiron-teal clip-diagonal my-16 opacity-20" data-id="element-37"></div>

        <div data-id="element-38">
          <h3 className="text-2xl font-oswald text-gray-300 mb-8 border-l-4 border-kiron-teal pl-4" data-id="element-39">
            Programas Especiales
          </h3>
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-40">
            {programs.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-kiron-dark p-6 border border-gray-800 flex items-center space-x-4 hover:border-kiron-teal transition-colors duration-300" data-id="element-41">
                <div className="p-3 bg-kiron-darker rounded-full" data-id="element-42">
                  <item.icon size={24} className="text-kiron-teal" data-id="element-43" />
                </div>
                <span className="font-oswald font-semibold tracking-wide uppercase text-sm" data-id="element-44">
                  {item.name}
                </span>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}